import React from 'react';
import { ActivityIndicator, StyleSheet, Text, TouchableOpacity, View } from 'react-native';
import { VoiceInputState } from '../hooks/useVoiceInput';

interface HoldToSpeakButtonProps {
    state: VoiceInputState;
    onStart: () => void;
    onStop: () => void;
}

export const HoldToSpeakButton: React.FC<HoldToSpeakButtonProps> = ({ state, onStart, onStop }) => {
    const listening = state === 'listening';
    const processing = state === 'processing';
    const label = listening ? 'Release to finish speaking' : 'Hold to speak your answer';

    return (
        <View style={styles.container}>
            <TouchableOpacity
                accessibilityLabel={label}
                accessibilityRole="button"
                accessibilityState={{ busy: processing, selected: listening }}
                disabled={processing}
                onPressIn={onStart}
                onPressOut={onStop}
                style={[styles.button, listening && styles.listening]}
            >
                {processing ? <ActivityIndicator color="#FFFFFF" /> : <Text style={styles.icon}>🎤</Text>}
                <Text style={styles.label}>{processing ? 'Processing…' : listening ? 'Listening…' : 'Hold to speak'}</Text>
            </TouchableOpacity>
            <Text style={styles.hint}>Hold the microphone while you speak.</Text>
        </View>
    );
};

const styles = StyleSheet.create({
    container: { alignItems: 'center', gap: 6 },
    button: { alignItems: 'center', backgroundColor: '#FA8C16', borderColor: '#9A4F00', borderRadius: 12, borderWidth: 2, flexDirection: 'row', gap: 8, justifyContent: 'center', minHeight: 56, paddingHorizontal: 18 },
    listening: { backgroundColor: '#D46B08', borderWidth: 4 },
    icon: { fontSize: 24 },
    label: { color: '#FFFFFF', fontSize: 18, fontWeight: '800' },
    hint: { color: '#475569', fontSize: 14, textAlign: 'center' },
});
